// extracted by mini-css-extract-plugin
export default {"title":"AddCoursesPopup_title__4LYwX","tableWrap":"AddCoursesPopup_tableWrap__KIs0z","action":"AddCoursesPopup_action__1+Qjn"};